import { render, staticRenderFns } from "./NarrativeMap.vue?vue&type=template&id=704bc8f2&"
import script from "./NarrativeMap.vue?vue&type=script&lang=js&"
export * from "./NarrativeMap.vue?vue&type=script&lang=js&"
import style0 from "./NarrativeMap.vue?vue&type=style&index=0&id=704bc8f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports